module.exports = __webpack_public_path__ + "static/capital-in-the-twentyfirst-century-1280f29ffb49cf2edf61b6b33b1086d5.jpg";